import React from 'react';
import { useIntl } from 'react-intl';
import type { UserProfileData } from '@contexts/AuthContextStore';
import ChipPicker from '../components/ChipPicker';
import { CAD_OPTIONS, CAE_OPTIONS, PLM_OPTIONS } from '../options';
import {
  SectionStack,
  StepSubtitle,
  StepTitle,
} from '../Onboarding.styled';

interface StepDesignStackProps {
  data: UserProfileData;
  errors: Partial<Record<keyof UserProfileData, string>>;
  update: (patch: Partial<UserProfileData>) => void;
}

const StepDesignStack: React.FC<StepDesignStackProps> = ({
  data,
  errors,
  update,
}) => {
  const intl = useIntl();
  return (
    <div data-testid="onboarding-step-designStack">
      <StepTitle>
        {intl.formatMessage({ id: 'onboarding.designStack.title' })}
      </StepTitle>
      <StepSubtitle>
        {intl.formatMessage({ id: 'onboarding.designStack.subtitle' })}
      </StepSubtitle>

      <SectionStack>
        <ChipPicker
          dataTestId="onboarding-cad"
          label={intl.formatMessage({ id: 'onboarding.designStack.cad' })}
          options={CAD_OPTIONS}
          columns={3}
          withOther
          value={data.cadSoftware ?? []}
          otherValue={data.cadOther}
          otherError={errors.cadOther}
          onChange={(next) => update({ cadSoftware: next })}
          onOtherChange={(next) => update({ cadOther: next })}
        />
        <ChipPicker
          dataTestId="onboarding-cae"
          label={intl.formatMessage({ id: 'onboarding.designStack.cae' })}
          options={CAE_OPTIONS}
          columns={3}
          withOther
          value={data.caeTools ?? []}
          otherValue={data.caeOther}
          otherError={errors.caeOther}
          onChange={(next) => update({ caeTools: next })}
          onOtherChange={(next) => update({ caeOther: next })}
        />
        <ChipPicker
          dataTestId="onboarding-plm"
          label={intl.formatMessage({ id: 'onboarding.designStack.plm' })}
          options={PLM_OPTIONS}
          columns={3}
          withOther
          value={data.plm ?? []}
          otherValue={data.plmOther}
          otherError={errors.plmOther}
          onChange={(next) => update({ plm: next })}
          onOtherChange={(next) => update({ plmOther: next })}
        />
      </SectionStack>
    </div>
  );
};

export default StepDesignStack;
